import { jsx } from 'react/jsx-runtime';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import { getComputedVerticalCollisionPadding } from '../../../../utils/collision-padding.mjs';
import { ScrollArea } from '../../../scroll-area/ScrollArea.mjs';
import { DROPDOWN_CONTENT_DEFAULT_COLLISION_PADDING } from '../../constants/style.mjs';
import { DropdownMenuPortal, DropdownMenuSubContent } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownContent } from '../../shared/styles/content.vanilla.mjs';
import { dropdownItemList } from '../../shared/styles/itemList.vanilla.mjs';
import { dropdownSubContentVerticalCollisionPaddingSize } from '../../shared/styles/variable.vanilla.mjs';
import { dropdownSubContentScrollAreaViewport } from './subContent.vanilla.mjs';

const DropdownSubContent = forwardRef(
  ({
    // Parent dropdown content의 negative block padding을 통해 시각적으로 보정합니다.
    alignOffset = -6,
    children,
    className: classNameFromProps,
    collisionPadding = DROPDOWN_CONTENT_DEFAULT_COLLISION_PADDING,
    portalContainer,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const style = useMemo(() => {
      const computedVerticalCollisionPadding = getComputedVerticalCollisionPadding({
        collisionPadding,
        fallbackCollisionPadding: DROPDOWN_CONTENT_DEFAULT_COLLISION_PADDING
      });
      return Object.assign(
        {},
        assignInlineVars({
          [dropdownSubContentVerticalCollisionPaddingSize]: `${computedVerticalCollisionPadding}px`
        }),
        styleFromProps
      );
    }, [collisionPadding, styleFromProps]);
    const className = classNames(dropdownContent, classNameFromProps);
    return /* @__PURE__ */ jsx(DropdownMenuPortal, { container: portalContainer, children: /* @__PURE__ */ jsx(
      DropdownMenuSubContent,
      {
        "data-scope": "dropdown",
        "data-part": "sub-content",
        alignOffset,
        className,
        collisionPadding,
        style,
        ref: forwardedRef,
        ...props,
        children: /* @__PURE__ */ jsx(ScrollArea, { "data-scope": "dropdown", "data-part": "sub-content-scroll-area", children: /* @__PURE__ */ jsx(
          ScrollArea.Viewport,
          {
            "data-scope": "dropdown",
            "data-part": "sub-content-scroll-area-viewport",
            className: dropdownSubContentScrollAreaViewport,
            children: /* @__PURE__ */ jsx(
              "div",
              {
                "data-scope": "dropdown",
                "data-part": "sub-content-item-list",
                className: dropdownItemList,
                children
              }
            )
          }
        ) })
      }
    ) });
  }
);

export { DropdownSubContent };
//# sourceMappingURL=SubContent.mjs.map
